import React, { ForwardRefRenderFunction } from 'react';
import styles from '../Calendar/Calendar.module.scss';
import { ReactComponent as CalendarSvg } from 'assets/svg/calendar.svg';

interface IBtn {
    value?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onClear?: () => void;
    isClearable?: boolean;
    hasValue?: boolean;
}

const CustomBtn: ForwardRefRenderFunction<HTMLButtonElement, IBtn> = (
    { onClick, value, onClear, isClearable, hasValue },
    ref,
) => {
    const clearDate = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.preventDefault();
        event.stopPropagation();
        onClear?.();
    };

    const clearDateByKeyboard = (event: React.KeyboardEvent<HTMLSpanElement>) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopPropagation();
        onClear?.();
    };

    return (
        <button className={styles.calendar} ref={ref} onClick={onClick} type="button">
            <span className={styles.calendarValue}>
                <CalendarSvg /> {value || '-- -- ---- -- -- ----'}
            </span>
            {isClearable && hasValue && (
                <span
                    className={styles.clearButton}
                    role="button"
                    tabIndex={0}
                    aria-label="Clear selected dates"
                    onMouseDown={(event) => {
                        event.preventDefault();
                        event.stopPropagation();
                    }}
                    onClick={clearDate}
                    onKeyDown={clearDateByKeyboard}
                >
                    x
                </span>
            )}
        </button>
    );
};
export default React.forwardRef(CustomBtn);
